<template>
    <div class="entry-content">
        <form @submit.prevent="handleFormSubmit">
            <h2>Information</h2>
            <input type="text" v-model="name" placeholder="Criteria Name" maxlength="400" required>
            <h2>Required Grade</h2>
            <input type="number" min="1" v-model="grade" placeholder="Required Grade" required>
            <h2>Order</h2>
            <input type="number" min="1" v-model="order" placeholder="Criteria Order" required>
            <div class="form-footer-wrapper">
                <div class="left-wrapper">
                    <button type="button" class="cancel delete" @click.prevent="handleDelete">Delete Criteria</button>
                </div>
                <div class="right-wrapper">
                    <button type="button" class="cancel" @click.prevent="handleRedirect">Cancel</button>
                    <input type="submit" class="save" value="Save" />
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import CheckApi from '@/api'

export default {
    name: 'AddLesson',
    data() {
		return {
            name: '',
            grade: '',
            order: ''
        }
    },
    mounted() {
        this.fetchCriteria()
    },
    methods: {
        async fetchCriteria() {
            const response = await CheckApi.getCriteriaTemplateById(this.$route.params.criteriaTemplateId)
            const {
                name,
                orderNumber,
                requiredGrade
            } = response.data.data
            this.name = name
            this.order = orderNumber
            this.grade = requiredGrade
        },
        async handleFormSubmit() {
            const {
                criteriaTemplateId
            } = this.$route.params
            await CheckApi.updateCriteriaTemplateById({name: this.name, criteriaTemplateId, orderNumber: this.order, requiredGrade: this.grade})
            this.handleRedirect()
        },
        handleRedirect() {
            this.$router.go(-1)
        },
        async handleDelete() {
            await CheckApi.handleCriteriaTemplateDelete(this.$route.params.criteriaTemplateId)
            this.handleRedirect()
        }
    }
}
</script>

<style lang="scss" scoped>
.form-footer-wrapper {
        display: flex;
        justify-content: space-between;

    .right-wrapper {
        display: flex;
    }
}

.cancel {
    background-color: transparent;
    border: .0625em solid #141638;

    &.delete {
        background-color: #ff8900;
        width: 150px !important;
        color: white;
        border: none;

        &:hover {
            color: white;
        }
    }

    &:hover {
        color: #141638;
    }
}

.form-footer-wrapper {
        display: flex;
    }

    .cancel {
        background-color: transparent;
        border: .0625em solid #141638;

        &:hover {
            color: #141638;
        }
    }

    .cancel,
    .save {
        width: 100px !important;
        height: 30px !important;
        border-radius: .75em !important;
        text-align: center !important;
        cursor: pointer;
    }

    .save {
        margin-left: 15px;
        background-color: #08ce97;
        border-style: none;
        color: #fff;
        border-radius: 0.75em;
        display: block !important;
        margin: 0 !important;
        margin-left: 15px !important;
        padding: 5px;
    }
</style>